import { IDefinitionChangeParam, IRole } from "@/hooks";
import { GridRowId } from "@mui/x-data-grid";
import { useState } from "react";
import { AdminTemplate, ConfirmationAddModal, ConfirmationListingTable } from "../../components"

export const SettingsConfirmationParameters = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [parametersData, setParametersData] = useState<IDefinitionChangeParam>();


  const handleAddButton = () => setIsOpen(true)

  const handleRowClick = (data: {
    id: GridRowId;
    row: IDefinitionChangeParam;
  }) => {
    setIsOpen(true);
    setParametersData(data.row);
  }

  return (
    <AdminTemplate headerProps={{headerTitle: 'Onay Parametreleri', onClickAddButton: handleAddButton}}>
      <ConfirmationListingTable isModalClosed={isOpen} onRowClick={handleRowClick}/>
      <ConfirmationAddModal parameter={parametersData}  onClose={() => {
        setIsOpen(false);
        setParametersData(undefined);
      }}   title={parametersData ? "Parametre Güncelle" : "Yeni Parametre Ekle"} isOpen={isOpen}/>
    </AdminTemplate>
  )
}
